
//-- Action creators
export const setSnackbarMessage = (data = null, type = false)  => {

    return {
        type: 'SET_SNACKBAR_MESSAGE',
        payload: data
    }
}

export const unsetSnackbar = (data = null) => {
	return {
		type: 'UNSET_SNACKBAR_MESSAGE',
		payload: ''
	}
}




// WEBPACK FOOTER //
// ./src/redux/actions/snackbarAction.js